
import type { Identifiable } from '@empathyco/playboard-core-domain'
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import { useAuditCopyToClipboard } from '../../../../composables/use-audit-copy-to-clipboard'
import AuditItemDetailsFieldValue from './audit-item-details-field-value.component.vue'

export interface AuditItemDetailsRow extends Identifiable {
  label: string
  previousState: unknown | undefined
  nextState: unknown | undefined
  stateChanged: boolean
  level: number
  key: string
}

export default defineComponent({
  name: 'AuditItemDetailsBody',
  components: {
    AuditItemDetailsFieldValue,
  },
  props: {
    rows: {
      type: Array as PropType<Array<AuditItemDetailsRow>>,
      required: true,
    },
  },
  setup() {
    const baseClass = 'epb-audit-item-details-body'

    const { hasCopyToClipboard } = useAuditCopyToClipboard()

    return {
      baseClass,
      hasCopyToClipboard,
    }
  },
})
